import API from "@/api/lib/api";

export const toggleItemStatus = async (categoryPath, id) => {
  try {
    const response = await API.put(`restaurant/${categoryPath}/${id}/toggle-status`);
    return response.data;
  } catch (error) {
    return error.response?.data || { status: "failure", message: "Something went wrong." };
  }
};
